import { lazy } from '../../../shared/deployment';

export const GoogleAnalytics = lazy(() => import('./GoogleAnalytics'));
